import {ComponentLoader} from '../vendor/component-loader/component-loader';

let loader = new ComponentLoader();
loader.loadComponents(document.body);
